const en = {
  ID_BUMPER_AD_INFO: "You can skip this ad in {count}",
  ID_BUMPER_AD_SKIP_BTN: "Skip Ad",
};

export default en;
